/* Carousel accessibility — the two gaps Swiper does NOT cover.
 *
 * IMPORTANT CONTEXT, so nobody re-adds the rest of this file later:
 * Swiper 8's A11y module is bundled and enabled BY DEFAULT. Verified in a
 * browser against this theme's own swiper-bundle.min.js — it already gives the
 * theme's <div> arrows `role="button"`, a label, `tabindex` that flips to -1 at
 * a dead end, and `aria-disabled`; it gives slides `role="group"` and an
 * "N / total" label; and it creates its own `.swiper-notification` live region.
 * It never touches the `disabled` property, so the focus-stealing failure does
 * not apply. Do not hand-roll any of that — it is already correct.
 *
 * What Swiper genuinely leaves undone:
 *
 *   1. prefers-reduced-motion. Swiper happily auto-rotates regardless. Nothing
 *      in the theme's CSS can stop a JS-driven autoplay, so it is stopped here.
 *
 *   2. Its notification region is `aria-live="assertive"`, which interrupts a
 *      screen reader mid-sentence on every slide change. The APG carousel
 *      pattern wants polite. Softened here.
 */
(function () {
  'use strict';

  function reducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function sweep(scope) {
    if (!scope || !scope.querySelectorAll) return;

    var els = scope.querySelectorAll('.swiper');
    for (var i = 0; i < els.length; i++) {
      var sw = els[i].swiper;
      if (!sw) continue;
      if (reducedMotion() && sw.autoplay && sw.autoplay.running) {
        sw.autoplay.stop();
      }
    }

    var notes = scope.querySelectorAll('.swiper-notification[aria-live="assertive"]');
    for (var j = 0; j < notes.length; j++) {
      notes[j].setAttribute('aria-live', 'polite');
    }
  }

  function boot() {
    // Sections build their sliders in their own deferred scripts, so sweep once
    // now and once after they have had a chance to mount.
    sweep(document);
    setTimeout(function () {
      sweep(document);
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    sweep(event.target);
    setTimeout(function () {
      sweep(event.target);
    }, 400);
  });

  // Honour a mid-session change to the OS setting.
  if (typeof window.matchMedia === 'function') {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', function () {
        sweep(document);
      });
    }
  }
})();
